/**
 * @generated SignedSource<<a5aa9dd24c85ee38c2cdde9d16ca32f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EmployeeWorkStatus = "NOT_WORKING" | "WORKING";
import { FragmentRefs } from "relay-runtime";
export type ListItemEmployees_employees$data = ReadonlyArray<{
  readonly id: string;
  readonly isLinkedToViewer: boolean;
  readonly name: string;
  readonly workStatus: EmployeeWorkStatus;
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
  readonly " $fragmentType": "ListItemEmployees_employees";
}>;
export type ListItemEmployees_employees$key = ReadonlyArray<{
  readonly " $data"?: ListItemEmployees_employees$data;
  readonly " $fragmentSpreads": FragmentRefs<"ListItemEmployees_employees">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ListItemEmployees_employees",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLinkedToViewer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "workStatus",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Avatar_employee"
    }
  ],
  "type": "Employee",
  "abstractKey": null
};

(node as any).hash = "9aaebd5df712355cf27884c23869f922";

export default node;
